import { TrendingDown, TrendingUp } from "lucide-react";
import { useNavigate } from "react-router-dom";

// Stats Card Component
const StatsCard = ({
  title,
  value,
  change,
  isPositive,
  icon: Icon,
  iconBg,
  link,
}) => {
  const navigate = useNavigate();
  return (
    <div className="stats-card">
      <div className="card-left">
        <div className="icon-container" style={{ background: iconBg }}>
          <Icon size={24} color="#fff" />
        </div>
        <div className="stats-info">
          <h2 className="stats-title">{title}</h2>
          <h3 className="stats-value">{value}</h3>
          <div className="stats-change">
            {isPositive ? <TrendingUp size={14} /> : <TrendingDown size={14} />}
            <span className={isPositive ? "positive" : "negative"}>
              {change}
            </span>
            <span className="change-label">Last Week</span>
          </div>
        </div>
      </div>
      <button
        className="view-more-btn"
        onClick={() => {
          navigate(link);
        }}
      >
        View More
      </button>
    </div>
  );
};

export default StatsCard;
